<template>
  <v-container class="ma-0 fill-height">
    <v-card
      height="100%"
      width="100%"
      class="pa-4"
    >
      <StoreItemEditInformation
        :program-id="programId"
        :store-item-id="storeItemId"
      />
    </v-card>
  </v-container>
</template>


<script>
import StoreItemEditInformation from '@/components/programs/store/EditInformation.vue';

export default {
  name: 'RewardEdit',
  components: {
    StoreItemEditInformation,

  },

  props: {
    programId: {
      type: String,
      required: true,
    },
    storeItemId: {
      type: String,
      default: null,
      required: true,
    },
  },
  data() {
    return {

    };
  },

};
</script>
